import React, {useMemo} from 'react'
import styled from 'styled-components'
import {useTranslation} from 'i18n'
import {Paragraph, Icon} from 'common/components'
import convertUnit from 'lib/unit'
import {TransactionDetailContentItemMultiCreatorActionsProps} from './TransactionDetailContentItemMultiCreatorActionsProps'

const StyledContainer = styled.div`
  display: flex;
  margin-left: ${convertUnit(-4)};
  gap: ${convertUnit(4)};
`

const StyledButton = styled.div`
  display: flex;
  align-items: center;
`

export default function TransactionDetailContentItemMultiCreatorActions({
  invoice,
  isRated,
  isRateable,
  style,
  onChatCreator,
  onRateCreator,
}: TransactionDetailContentItemMultiCreatorActionsProps) {
  const is_rated = useMemo(
    () => isRated[invoice.invoice_id] ?? invoice.is_rated,
    [invoice.invoice_id, invoice.is_rated, isRated],
  )
  const {translate} = useTranslation()

  return (
    <StyledContainer style={style}>
      <StyledButton
        role="button"
        style={{
          cursor: 'pointer',
        }}
        onClick={(e) => {
          e.stopPropagation()
          onChatCreator(invoice)
        }}>
        <Icon size={16} marginLeft={0} type="message" color="primary_5" />
        <Paragraph fontWeight="bold" color="primary_5">
          {translate('global:chat')}
        </Paragraph>
      </StyledButton>
      {isRateable && (
        <>
          <StyledButton
            style={{
              marginLeft: convertUnit(4),
            }}>
            <Paragraph color="gray_3">•</Paragraph>
          </StyledButton>
          {is_rated ? (
            <StyledButton>
              <Icon size={16} color="gray_3" type="check" />
              <Paragraph fontWeight="bold" color="gray_3">
                {translate('global:isRated')}
              </Paragraph>
            </StyledButton>
          ) : (
            <StyledButton
              role="button"
              style={{
                cursor: 'pointer',
              }}
              onClick={(e) => {
                e.stopPropagation()
                onRateCreator(invoice)
              }}>
              <Icon size={16} color="primary_5" type="star-solid" />
              <Paragraph fontWeight="bold" color="primary_5">
                {translate('messages:notificationPurchaseReviewButton')}
              </Paragraph>
            </StyledButton>
          )}
        </>
      )}
    </StyledContainer>
  )
}
